import { h, render } from 'preact'
import MonogramInput from '../components/monogram-input'

export default function ProductMonogram() {
  this.renderInput = function() {
    const addToCart = document.getElementById('addToCart')
    document.querySelectorAll('.product-monogram').forEach((element) => {
      render(h(MonogramInput, Object.assign({ addToCart }, element.dataset)), element)
    })
  }
}
